// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","Partners":"Footer_Partners__sNpl3"};